import React from "react";
import { EntityType } from "@/services/hooks/entities/useEntityType";
import { UserData } from "@/entities/users/types";
import { EntityData } from "@/services/api/types";
import NewQuickViewContent from "@/components/layouts/NewQuickView/NewQuickViewContent";

export interface NewQuickViewProps {
  isOpen: boolean;
  entityId: string | null;
  entityType: EntityType;
  onClose: () => void;
  handleOpenQuestionnaire?: (questionnaireId?: string) => void;
  isKanbanLayout?: boolean;
  onEntityUpdate?: (updatedEntity: EntityData) => void;
  userData?: UserData;
  isTabView?: boolean;
}

const NewQuickView: React.FC<NewQuickViewProps> = ({
  isOpen,
  entityId,
  entityType,
  onClose,
  handleOpenQuestionnaire,
  isKanbanLayout = false,
  onEntityUpdate,
  userData,
  isTabView = false
}) => {
  if (!isOpen || !entityId) {
    return null;
  }

  return (
    <NewQuickViewContent
      entityId={entityId}
      entityType={entityType}
      onClose={onClose}
      handleOpenQuestionnaire={handleOpenQuestionnaire}
      isKanbanLayout={isKanbanLayout}
      onEntityUpdate={onEntityUpdate}
      userData={userData}
      isTabView={isTabView}
    />
  );
};

export default NewQuickView;
